module.exports = __webpack_public_path__ + "img/sport_archery.aa5f994a.png";